import iconHome from './../images/icon-home.svg';
import iconHomeHover from './../images/icon-home-white.svg';
import iconCondo from './../images/icon-condo.svg';
import iconCondoHover from './../images/icon-condo-white.svg';
import iconMobile from './../images/icon-mobile.svg';
import iconMobileHover from './../images/icon-mobile-white.svg';
import iconCommercial from './../images/icon-commercial.svg';
import iconCommercialHover from './../images/icon-commercial-white.svg';

const icons = [
  { name: 'home', path: iconHome },
  { name: 'homeHover', path: iconHomeHover },
  { name: 'condo', path: iconCondo },
  { name: 'condoHover', path: iconCondoHover },
  { name: 'mobile', path: iconMobile },
  { name: 'mobileHover', path: iconMobileHover },
  { name: 'commercial', path: iconCommercial },
  { name: 'commercialHover', path: iconCommercialHover },
];

export default icons;
